import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { PodcastState } from './types'
import state from './state'
import getters from './getters'
import mutations from './mutations'

const module: Module<PodcastState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
}

export default module
